var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"width":"700px"},on:{"close":function($event){return _vm.$emit('update:visible', false)}}},[_c('div',{staticClass:"container"},[(_vm.protocolType == 2)?_c('privacy'):(_vm.protocolType == 3)?_c('disclaimer'):(_vm.protocolType == 1)?_c('zh'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }